import { ExtremwetterschutzSelbstbeteiligung, Selbstbeteiligung } from '@ps20/bff-models';


type AnimalType = 'Hund' | 'Katze' | 'Pferd';

export interface SelbstbeteiligungLabel {
  key: Selbstbeteiligung;
  value: string;
}

export const mapSelbstbeteiligungToDropdownDisplayValue = (
  selbstbeteiligung: Selbstbeteiligung,
  selbstbeteiligungLabels: SelbstbeteiligungLabel[] = [],
): string => {
  const values = {
    [Selbstbeteiligung.SELBSTBETEILIGUNG_0000]: 'keine',
    [Selbstbeteiligung.SELBSTBETEILIGUNG_0150]: '150 €',
    [Selbstbeteiligung.SELBSTBETEILIGUNG_0300]: '300 €',
    [Selbstbeteiligung.SELBSTBETEILIGUNG_0500]: '500 €',
    [Selbstbeteiligung.SELBSTBETEILIGUNG_1000]: '1.000 €',
    [Selbstbeteiligung.SELBSTBETEILIGUNG_2000]: '2.000 €',
    [Selbstbeteiligung.SELBSTBETEILIGUNG_5000]: '5.000 €',
    [Selbstbeteiligung.SELBSTBETEILIGUNG_10000]: '10.000 €',
    [Selbstbeteiligung.SELBSTBETEILIGUNG_10_PROZENT]: '10 %',
    [Selbstbeteiligung.SELBSTBETEILIGUNG_20_PROZENT]: '20 %',
    [Selbstbeteiligung.SELBSTBETEILIGUNG_30_PROZENT]: '30 %',
    [Selbstbeteiligung.SELBSTBETEILIGUNG_40_PROZENT]: '40 %',
  };
  selbstbeteiligungLabels.forEach(label => {
    values[label.key] = label.value;
  });
  return values[selbstbeteiligung];
};

export const mapExtremWetterschutzSelbstbeteiligungToDropdownDisplayValue = (
  selbstbeteiligung: ExtremwetterschutzSelbstbeteiligung,
): string => {
  return {
    [ExtremwetterschutzSelbstbeteiligung.SELBSTBETEILIGUNG_0]: '0 €',
    [ExtremwetterschutzSelbstbeteiligung.SELBSTBETEILIGUNG_0500]: '500 €',
    [ExtremwetterschutzSelbstbeteiligung.SELBSTBETEILIGUNG_1000]: '1.000 €',
    [ExtremwetterschutzSelbstbeteiligung.SELBSTBETEILIGUNG_2000]: '2.000 €',
    [ExtremwetterschutzSelbstbeteiligung.SELBSTBETEILIGUNG_3000]: '3.000 €',
    [ExtremwetterschutzSelbstbeteiligung.SELBSTBETEILIGUNG_4000]: '4.000 €',
    [ExtremwetterschutzSelbstbeteiligung.SELBSTBETEILIGUNG_5000]: '5.000 €',
    [ExtremwetterschutzSelbstbeteiligung.SELBSTBETEILIGUNG_10000]: '10.000 €',
    [ExtremwetterschutzSelbstbeteiligung.SELBSTBETEILIGUNG_20000]: '20.000 €',
    [ExtremwetterschutzSelbstbeteiligung.SELBSTBETEILIGUNG_50000]: '50.000 €',
    [ExtremwetterschutzSelbstbeteiligung.SELBSTBETEILIGUNG_100000]: '100.000 €',
    [ExtremwetterschutzSelbstbeteiligung.SELBSTBETEILIGUNG_150000]: '150.000 €',
  }[selbstbeteiligung];
};

export const mapSelbstbeteiligungToZusammenfassungDisplayValue = (
  animalType: AnimalType,
  selbstbeteiligung: Selbstbeteiligung
): string | undefined => {
  const selbstbeteiligungLabels: { animalType: AnimalType; labels: SelbstbeteiligungLabel[] }[] = [
    {
      animalType: 'Hund',
      labels: [
        { key: Selbstbeteiligung.SELBSTBETEILIGUNG_0000, value: 'keine' },
        { key: Selbstbeteiligung.SELBSTBETEILIGUNG_10_PROZENT, value: '10 % (max. 500 €) ' },
        { key: Selbstbeteiligung.SELBSTBETEILIGUNG_20_PROZENT, value: '20 % (max. 1.000 €)' },
      ],
    },
    {
      animalType: 'Katze',
      labels: [
        { key: Selbstbeteiligung.SELBSTBETEILIGUNG_0000, value: 'keine' },
        { key: Selbstbeteiligung.SELBSTBETEILIGUNG_10_PROZENT, value: '10 % (max. 500 €) ' },
        { key: Selbstbeteiligung.SELBSTBETEILIGUNG_20_PROZENT, value: '20 % (max. 1.000 €)' },
      ],
    },
    {
      animalType: 'Pferd',
      labels: [
        { key: Selbstbeteiligung.SELBSTBETEILIGUNG_0000, value: 'keine' },
        { key: Selbstbeteiligung.SELBSTBETEILIGUNG_10_PROZENT, value: '10 % (max. 1.500 €) ' },
        { key: Selbstbeteiligung.SELBSTBETEILIGUNG_20_PROZENT, value: '20 % (max. 3.000 €)' },
      ],
    },
  ];

  return selbstbeteiligungLabels
    .find(item => item.animalType === animalType)
    ?.labels.find(label => label.key === selbstbeteiligung)
    ?.value;
};

export const getDefaultExtremwetterschutzSelbstbeteiligung = (
  zone: string,
): ExtremwetterschutzSelbstbeteiligung => {
  switch (Number(zone)) {
    case 1:
      return ExtremwetterschutzSelbstbeteiligung.SELBSTBETEILIGUNG_1000;
    case 2:
      return ExtremwetterschutzSelbstbeteiligung.SELBSTBETEILIGUNG_2000;
    case 3:
      return ExtremwetterschutzSelbstbeteiligung.SELBSTBETEILIGUNG_4000;
    case 4:
      return ExtremwetterschutzSelbstbeteiligung.SELBSTBETEILIGUNG_5000;
    case 98:
      return ExtremwetterschutzSelbstbeteiligung.SELBSTBETEILIGUNG_3000;
    default:
      return ExtremwetterschutzSelbstbeteiligung.SELBSTBETEILIGUNG_1000;
  }
};
